import { API, IMAGE_BASE_URL } from "../../common/Constants";

const generateRandomApprovalTime = () => {
  const approvalTimes = ['Very Fast', 'Fast', 'Instant', 'Slow'];
  return approvalTimes[Math.floor(Math.random() * approvalTimes.length)];
};

const generateRandomPhoneNumber = () => {
  return `+65 ${Math.floor(Math.random() * 90000000) + 10000000}`;
};

const generateRandomLoanToValue = () => {
  const loanToValues = ['Low', 'Instant', 'High', 'Very High'];
  return loanToValues[Math.floor(Math.random() * loanToValues.length)];
};

const generateRandomBoolean = () => {
  return Math.random() < 0.5;
};

const generateRandomVouchersName = () => {
  const vouchersName = ['COE', 'PARF', 'Body Only'];
  return vouchersName[Math.floor(Math.random() * vouchersName.length)];
};

const generateRandomVoucher = () => {
  return {
    vouchersName:generateRandomVouchersName(),
    interestRate: `${(0.65 + Math.random() * 0.6).toFixed(2)}%`,
    forallCustomers: `${Math.floor(Math.random() * 1000)} / 1000 voucher(s) left`,
    validFrom: '12/12/2022 till Further Notice',
    eligibleFloorAmount: `$${(900000 + Math.random() * 100000).toFixed(2)} to $${(900000 + Math.random() * 100000).toFixed(2)}`,
    youRedeemed: `${Math.floor(Math.random() * 3)}/3`,
    voucherApply:generateRandomBoolean(),
  };
};

export const generateRandomData = () => {
  const numEntries = 10;
  const data = [];

  for (let i = 0; i < numEntries; i++) {
    const entry = {
      image: `${IMAGE_BASE_URL}/public/uploads/loanproduct/6501382fb7c3b.jpg`,
      name: 'Standard Chartered',
      premium: generateRandomBoolean(),
      featured: generateRandomBoolean(),
      contactNo: generateRandomPhoneNumber(),
      address: 'BLK 234 Ohhto Street 68 S527234',
      email: 'sales@sccarbrokers.com',
      InterestRate: `${(0.65 + Math.random() * 0.6).toFixed(2)}%`,
      adminFee: `$${(500 + Math.random() * 1000).toFixed(2)}`,
      approvalTime: generateRandomApprovalTime(),
      loanToValue: generateRandomLoanToValue(),
      eligibleVouchers: Array.from({ length: 2 }, generateRandomVoucher),
    };

    data.push(entry);
  }

  return data;
};
